import { lazy } from 'react';
import Login from '../pages/Login';

const CertificateClaimEntry = lazy(() =>
  import('../pages/CertificateClaim'),
);
const Help = lazy(() => import('../pages/Help'));

export default [
  {
    path: '/certificate/claim',
    exact: true,
    component: CertificateClaimEntry,
  },
  {
    path: '/p/:alias/certificate/:certificateId',
    exact: true,
    component: Login,
  },
  {
    path: '/p/:alias/google-wallet',
    exact: true,
    component: Login,
  },
  {
    path: '/p/:alias/:serialNumber?',
    component: Login,
  },
  {
    path: '/help',
    component: Help,
  },
];
